import Image from 'next/image';

import { images } from '~/landing/assets';

export const FloatingShape = () => (
  <div className="pointer-events-none absolute inset-0 z-20 grid place-items-center overflow-hidden">
    <div className="relative size-[300%] -translate-x-40 -translate-y-1/4 sm:translate-x-0 lg:size-[400%]">
      <Image
        fill
        priority
        alt=""
        className="hidden object-contain sm:block"
        src={images.shape}
      />
    </div>
  </div>
);
